import convertCurrency from "~/lib/helpers/currencyConverter";
import { MAX_SQFT, MAX_SQM, SQM_TO_SQFT } from "~/lib/constants/generalConstants";
import Content from "../Modals/AddListingEarnCalcModal/Content";
import { RegionConfig } from "~/store/regionConfigStore";

interface AddListingCalculatorProps {
    calculation: number;
    desks: number;
    setDesks: (val: number) => void;
    office: "premium" | "superior" | "economical";
    setOffice: (val: "premium" | "superior" | "economical") => void;
    baseRate: number;
    spaceType: string;
    setSpaceType: (val: string) => void;
    area: number;
    setArea: (val: number) => void;
    units: "sm" | "sf";
    setUnits: (val: "sm" | "sf") => void;
    userCurrency: string;
    handleLocationSelect: (val: string, location?: string) => void;
    listingDataSource?: any[];
    isMobile?: boolean;
    isSticky?: boolean;
    regionData?: RegionConfig;
    headingAs?: "h1" | "h2" | "h3";
    staticTitle?: string;
}

export function AddListingCalculator({
    calculation,
    desks,
    setDesks,
    office,
    setOffice,
    baseRate,
    spaceType,
    setSpaceType,
    area,
    setArea,
    units,
    setUnits,
    userCurrency,
    handleLocationSelect,
    listingDataSource,
    isMobile,
    isSticky,
    regionData,
    headingAs: Heading = "h2",
    staticTitle
}: AddListingCalculatorProps) {


    const handleAreaSliderChange = (values) => {
        const sliderValue = values[0];
        if (units === "sm") {
            setArea(sliderValue);
        } else if (units === "sf") {
            setArea(Number((sliderValue / SQM_TO_SQFT).toFixed(2)));
        }
    };

    // For showing values in both sm and sf
    const areaDisplaySqm =
        Math.round(area);
    const areaDisplaySqft =
        Math.round(area * SQM_TO_SQFT);

    // For slider value based on unit
    const sliderValue = units === "sm" ? area : Math.round(area * SQM_TO_SQFT);
    const sliderMax = units === "sm" ? MAX_SQM : MAX_SQFT;
    // For showing values in both sm and sf



    return (
        <div className='flex flex-col w-full max-w-2xl justify-center items-center'>
            <div className='w-full max-w-xl text-left'>
                {staticTitle && (
                    <Heading className='text-sm text-gray-500 uppercase font-semibold mb-1'>
                        {staticTitle}
                    </Heading>
                )}
                <p className='text-3xl md:text-5xl font-bold leading-15 line-clamp-2' aria-live="polite">
                    {listingDataSource && listingDataSource?.length > 0 ? (
                        <>
                            Your Office Could
                            <br /> Earn{" "}
                            <span className='text-base-red inline'>
                                {units === "sf"
                                    ? convertCurrency(areaDisplaySqft * baseRate, userCurrency, regionData?.currency)
                                    : convertCurrency(calculation, userCurrency, regionData?.currency)}
                            </span>
                            {" "}monthly
                        </>
                    ) : (
                        <span>Your property could make money on Office Hub</span>
                    )}
                </p>
            </div>

            <div className="w-full max-w-xl">
                <Content
                    office={office}
                    setOffice={setOffice}
                    setDesks={setDesks}
                    desks={desks}
                    spaceType={spaceType}
                    setSpaceType={setSpaceType}
                    units={units}
                    setUnits={setUnits}
                    area={area}
                    setArea={setArea}
                    handleLocationSelect={handleLocationSelect}
                    areaDisplaySqft={areaDisplaySqft}
                    areaDisplaySqm={areaDisplaySqm}
                    sliderMax={sliderMax}
                    handleAreaSliderChange={handleAreaSliderChange}
                    sliderValue={sliderValue}
                    isMobile={isMobile}
                    isSticky={isSticky}
                />
            </div>
        </div>
    );
}
